import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { HeaderSubLabel, SubColumnDef, subColumnField } from '@components/DataGrid/subColumns';
import LocationCell from '@components/DataGrid/LocationCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const dehireField = 'Dehire';
const headerDisplayName = 'Empty RT/PU';

/** Sub-values of the Dehire column sortable via hidden companion columns */
const dehireSubColumns: SubColumnDef<DispatchLeg>[] = [
	{ key: 'city', label: 'City', valueGetter: (row) => row.dehireCity },
	{ key: 'state', label: 'State', valueGetter: (row) => row.dehireState }
];

const dehireSubLabels: HeaderSubLabel[] = dehireSubColumns.map((sub) => ({
	label: sub.label,
	field: subColumnField(dehireField, sub.key)
}));

const dehireDefinition: GridColDefExtended<DispatchLeg> = {
	field: dehireField,
	minWidth: 75,
	width: 120,
	headerName: 'Dehire Name|||Dehire City|||Dehire State',
	headerDisplayName,
	subColumns: dehireSubColumns,
	/** Mobile cards invoke renderHeader without params (RenderCardCell), so they fall back to the
	 * static secondaryText instead of mounting the grid-subscribing sort labels per card */
	renderHeader: (params) => (
		<RenderHeader
			primaryText={headerDisplayName}
			subLabels={params.field ? dehireSubLabels : undefined}
			secondaryText='City, State'
		/>
	),
	renderCell: ({ row }) => (
		<LocationCell
			name={row.dehireName}
			city={row.dehireCity}
			state={row.dehireState}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { dehireName, dehireCity, dehireState } = row;
				return caseInsensitiveIncludes(value, [dehireName, dehireCity, dehireState]);
			});
	},
	valueGetter: (_, row: DispatchLeg) =>
		`${row.dehireName?.replaceAll(',', '') ?? ''}|||${
			row.dehireCity?.replaceAll(',', '') ?? ''
		}|||${row.dehireState?.replaceAll(',', '') ?? ''}`.replaceAll(',', ''),
	sortable: true,
	sortComparator: (v1, v2, cellParams1) => {
		if (typeof v1 === 'string' && typeof v2 === 'string') {
			return defaultSortComparator(v1.split('|||')[0], v2.split('|||')[0], cellParams1);
		}

		return 0;
	}
};

export default dehireDefinition;
